import {APP_INITIALIZER, NgModule} from '@angular/core';
import * as Logger from 'js-logger';
import {EMPTY} from 'rxjs';
import {setupLogging} from '@app/shared/logging';
import {TimeServiceBase} from '@app/shared/time.service.base';
import {environment} from '@environment/environment';

@NgModule({
    providers: [
        {
            provide: APP_INITIALIZER,
            multi: true,
            useFactory: (timeService: TimeServiceBase) => () => {
                setupLogging(timeService, environment.production ? Logger.INFO : Logger.DEBUG);
                return EMPTY;
            },
            deps: [TimeServiceBase],
        },
    ],
})
export class LoggingModule {
}
